import { Row } from "antd";
import React from "react";
import packageJson from '../../../../package.json';

const FooterComponent = () => {
  return (
      <Row align="bottom" justify="center">
        <div className="footer">Version {packageJson.version} | © TaskUs @ {new Date().getFullYear().toString()} | <a rel="noreferrer" href="https://www.taskus.com/security/" target="_blank">Security</a>  </div>
      </Row>
  );
};

export default FooterComponent;
